import { useSelector } from '@ecommerce/nest-ssr/common';
import { SeoDataInterface } from 'modules/seo-module/interfaces/seo-data.interface';

export const useSeo = (): SeoDataInterface => useSelector((state: { seo: SeoDataInterface; }) => state.seo);
